import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { history } from 'src/core/router'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {},
    LotTimeInfo: {},
    rounds: 0,
    coins: 0,
    betResult: null,
    rankList: [],
    historyList: [],
    rewardCoins: 0,
    betFruit: -2,
    allPeopleBet: [],
    onlyOne: 1,
    canGetInfo: true,
    isSuccess: null,
    fruitTimeInfo: {
      canBet: false,
      date: "2022-08-18",
      round: 0,
      tsNow: 0,
      tsZero: 0
    },
    isEnd: false,
  }

  @action async GetUserInfoWeb() {
    this.data.notNetwork = false
    let d = await http.post('/web/MyAccountInfo', {})
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      this.data.coins = d && d.res && d.res.gold
    } else {
      this.data.notNetwork = true
    }
  }

  @action async GetLotteryTime() {
    let d = await http.post('/web/games/wheel/time', {})
    if (d && d.code == 0 && d.res) {
      let timestamp = Date.parse(new Date()) / 1000 //当前时间
      this.data.rounds = d.res.round
      // if (timestamp - d.res.tsNow < 40 && timestamp - d.res.tsNow > -40) {
      //   d.res.tsNow = timestamp
      // }
      d.res.tsNow = (d.res.tsNow > timestamp) ? d.res.tsNow : timestamp
      this.data.LotTimeInfo = d.res
      return d.res
    }
    return this.data.LotTimeInfo
  }

  @action async BetGold(gemArr) {
    let d = await http.post('/web/games/wheel/bet', {
      wheels: gemArr
    })
    this.data.isSuccess = d && d.res
    this.data.isEnd = true
    console.log('押注', d)
  }
  @action async BetResult() {
    this.data.notNetwork = false
    let d = await http.post('/web/games/wheel/result')
    console.log('结果', d)
    this.data.betResult = d && d.res && d.res.betFruit
    this.data.rewardCoins = d && d.res && d.res.rewardCoins
    this.data.betFruit = d && d.res && d.res.betFruit
    this.data.coins = d && d.res && d.res.coins
    this.data.onlyOne = d && d.res && d.res.onlyOne
    this.data.canGetInfo = true
  }
  @action async getBetRank() {
    this.data.notNetwork = false
    let d = await http.post('/web/games/wheel/rank')
    this.data.rankList = d && d.res && d.res.list
  }
  @action async getBetHistory() {
    this.data.notNetwork = false
    let d = await http.post('/web/games/wheel/user/history')
    this.data.historyList = d && d.res && d.res
  }
  @action async getAllBet() {
    if (this.data.canGetInfo == false) {
      return
    }
    this.data.canGetInfo = false
    let d = await http.post('/web/games/wheel/all/bet')
    this.data.canGetInfo = true
    console.log(d, 'allbet')
    this.data.allPeopleBet = d && d.res && d.res.list
  }
  @action async clearBet() {
    this.data.notNetwork = false
    this.data.allPeopleBet = []
  }
  @action async setBetFruit() {
    this.data.notNetwork = false
    this.data.betFruit = -2
  }
  @action async changeIsEnd() {
    this.data.isEnd = false
  }
}



// WEBPACK FOOTER //
// src/store/activity/lottery.js